import { render, staticRenderFns } from "./ScrapFormer.vue?vue&type=template&id=004d4096&"
import script from "./ScrapFormer.vue?vue&type=script&lang=js&"
export * from "./ScrapFormer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports